module.exports = "<span gw-feature-toggler category=\"faq\">\r\n    <a href=\"#\" ui-sref=\"faq({ 'faqScrollTo': fragment })\" target=\"{{ newpage ? '__blank' : '_self' }}\">\r\n        <span ng-if=\"defaultContent\">{{ inlineContent | translate }}</span>\r\n        <span ng-transclude></span>\r\n    </a>\r\n</span>\r\n"


//////////////////
// WEBPACK FOOTER
// ./common/grunt/webpack/loaders/text-loader!./common/js/src/edge/faq/directives/templates/faq-link.html
// module id = 502
// module chunks = 0